import React, { useEffect, useState } from "react";
import "./claim.scss";
import Navbar from "../landing/header/Navbar";
import { Accordion, Modal } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useWeb3React } from "../../hooks/useWagmiCompat";
import Loader from "../../hooks/loader";
import ReactPaginate from "react-paginate";
import moment from "moment";
import Claim1 from "../../hooks/chinaFunction/claim";
import ClaimAll from "../../hooks/chinaFunction/claimAll";
import { array } from "i/lib/util";
import { toast } from "react-toastify";
import EthPrice from "../../hooks/chinaFunction/ethPrice";
import { intersection } from "lodash";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Environment from "../../utils/Environment";
import { setupNetwork } from "../../utils/wallet";
import { storeReferrer } from "@sharemint/sdk";
import { saveAddress } from "@sharemint/sdk";
import Footer from "../landing/Footer/Footer";
import {
  formatDisplayPrice,
  formatDisplayTokenAmount,
  formatDisplayPaymentAmount,
  fromBaseUnits,
} from "../../utils/formatDisplay";

const CHAIN = process.env.REACT_APP_CHAIN_ID;

function kaiFromTokenPurchase(purchasedNum, priceFactor, roundPriceRaw) {
  const roundPx = fromBaseUnits(roundPriceRaw, 18);
  if (!roundPx) return "0";
  return formatDisplayTokenAmount((purchasedNum * priceFactor) / roundPx);
}

function kaiFromEthPurchase(purchasedNum, ethUsd, roundPriceRaw) {
  const roundPx = fromBaseUnits(roundPriceRaw, 18);
  if (!roundPx) return "0";
  return formatDisplayTokenAmount((purchasedNum * ethUsd) / roundPx);
}

function kaiFromUsdPurchase(purchasedNum, roundPriceRaw) {
  const roundPx = fromBaseUnits(roundPriceRaw, 18);
  if (!roundPx) return "0";
  return formatDisplayTokenAmount(purchasedNum / roundPx);
}

const Claim = () => {
  const Presale = Environment?.presale;
  let sharemintValue = localStorage.getItem("sharemint");
  const [ethPricevalue, setEthPrice] = useState(0);
  const { ethPrice } = EthPrice();
  const location = useLocation();
  let now = Date.now();
  const role = localStorage?.getItem("role_ins");
  const { claim1 } = Claim1();
  const { claimAll } = ClaimAll();
  const [pageCount, setPageCount] = useState(0);
  const [totalLength, setTotalLength] = useState(0);
  const [totalArry, settotalArry] = useState([]);
  const { account, chainId } = useWeb3React();
  const [mainLoader, setMainLoader] = useState(false);
  const [mainLoader1, setMainLoader1] = useState(false);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [check, setCheck] = useState(false);
  const [activeKey, setActiveKey] = useState(null);
  const [show5, setShow5] = useState(false);
  const handleClose5 = () => {
    setShow5(false);
  };
  const handleShow5 = () => setShow5(true);

  const witterHandler = () => {
    const weChatShareUrl = "https://x.com/Gems_VIP_";

    // Open the WeChat share link in a new window
    window.open(weChatShareUrl, "_blank");
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const buy = params.get("buy");

    if (buy === "true") {
      handleShow5();
    }
  }, [location.search]);

  useEffect(() => {
    storeReferrer();
    return () => {};
  }, []);
  // const handlePageClick = (e) => {
  //   setMainLoader1(true);
  //   const selectedPage = e.selected;
  //   let skip = "";
  //   if (e.selected > 0) {
  //     skip = JSON.stringify(e.selected * limit);
  //     setPage(selectedPage);
  //   } else {
  //     skip = JSON.stringify(0);
  //     setPage(0);
  //   }
  //   var data = JSON.stringify({
  //     query: `query MyQuery {
  //       investments(
  //         where: {by: "${account}"}
  //         orderBy: blockTimestamp
  //         orderDirection: desc
  //         first:10
  //         skip: ${skip}
  //       ) {
  //         blockTimestamp
  //         amountPurchased
  //         by
  //         code
  //         tokenPurchased
  //         id
  //         price
  //         transactionHash
  //         tokenSelected
  //         round
  //       }
  //     }`,
  //   });
  //   var config = {
  //     method: "post",
  //     url: "https://api.thegraph.com/subgraphs/name/saifdevblochain/GEMS",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };
  //   axios(config)
  //     .then(function (response) {
  //       setPageCount(totalLength / limit);
  //       settotalArry(response?.data?.data?.investments);
  //       ClaimAll111();
  //       setMainLoader1(false);
  //     })
  //     .catch(function (error) {
  //       setMainLoader1(false);
  //     });
  // };
  // const nftMainArryHandler1 = async () => {
  //   setMainLoader1(true);
  //   var data = JSON.stringify({
  //     query: `query MyQuery {
  //       investments(
  //         where: {by: "${account}"}
  //         orderBy: blockTimestamp
  //         orderDirection: desc
  //       ) { blockTimestamp
  //         amountPurchased
  //         by
  //         code
  //         tokenPurchased
  //         id
  //         price
  //         transactionHash
  //         tokenSelected
  //         round
  //       }
  //     }`,
  //     variables: {},
  //   });
  //   var config = {
  //     method: "post",
  //     url: "https://api.thegraph.com/subgraphs/name/saifdevblochain/GEMS",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };
  //   await axios(config)
  //     .then(async function (response) {
  //       console.log(response,'response?.data?.data?.investments');
  //       setPageCount(response?.data?.data?.investments?.length / limit);

  //       setTotalLength(response?.data?.data?.investments?.length);
  //       setMainLoader1(false);
  //     })
  //     .catch(function (error) {
  //       setMainLoader1(false);
  //       console.log(error, "error");
  //     });
  // };
  const code = localStorage?.getItem("accessCode");
  const email = localStorage?.getItem("email");
  // useEffect(()=>{
  //   // console.log('usefffef',email,code);
  //   if(!email||!code){
  //   history.push('/')
  //   }
  // },[])
  useEffect(() => {
    //  console.log(chainId,'chainIdchainId');
    if (account) {
      if (chainId != parseInt(CHAIN)) {
        setupNetwork();
      }
    }
  }, [account, chainId]);
  const nftMainArryHandler2latest = async () => {
    setMainLoader1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        purchases(
          where: {by: "${account}"}
          orderBy: blockTimestamp
          orderDirection: desc
        ) {
          amountPurchased:amountPurchased
          blockTimestamp
          by
          code
          tokenPurchased:tokenPurchased
          id
          nftAmounts
          round
          roundPrice
          token
          tokenPrice
          tokenSelected
          transactionHash
          type 
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: "https://api.studio.thegraph.com/query/63987/leia/v1.2.2",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        // console.log(response, 'response?.data?.data?.investments mainn1');
        // nftMainArryHandler2latestFromAdmin(response?.data?.data?.purchases)
        // settotalArry(response?.data?.data?.investments);
        // setMainLoader1(false);
        // ClaimAll111();
        // settotalArry(response?.data?.data?.investments);
        // instittion(response?.data?.data?.investments)
      })
      .catch(function (error) {
        setMainLoader1(false);
        console.log(error, "error");
      });
  };
  const nftMainArryHandler2latestFromAdmin = async () => {
    setMainLoader1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        purchases(
          orderBy: blockTimestamp
    orderDirection: desc
          where: {by: "${account}"}) {
            type
            transactionHash
            tokenSelected
            tokenPurchased
            tokenPrice
            token
            roundPrice
            round
            nftAmounts
            id
            code
            by
            blockTimestamp
            amountPurchased
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: Environment.privateSaleGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        // console.log(response, 'response?.data?.data?.investments mainn1 sddasasa');
        let a = response?.data?.data?.purchases;

        settotalArry(a);
        setMainLoader1(false);
      })
      .catch(function (error) {
        setMainLoader1(false);
        console.log(error, "error");
      });
  };

  const safeDateta = async () => {
    if (sharemintValue) {
      saveAddress({ slug: "leia", address: account });
    }
  };
  useEffect(() => {
    if (account) {
      safeDateta();
      // nftMainArryHandler2()
      nftMainArryHandler2latestFromAdmin();
      firstTimeData();
    } else {
      settotalArry(null);
    }
  }, [account, ethPricevalue]);

  const [show, setShow] = useState(false);
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handler121 = async (e) => {
    setMainLoader(true);
    let z = e.currentIndex;
    try {
      let t = await claim1(z);
      if (t) {
        setMainLoader(false);
        window.location.reload();
      }
    } catch (err) {
      console.log(err, "err");
      setMainLoader(false);
      toast.error("Transaction reverted");
    }
  };
  const ClaimAll11 = async (e) => {
    let dummy = [];
    totalArry.map((e, i) => {
      if (now > e?.ReleaseTime * 1000 && e?.isClaimed == false) {
        // console.log(e, "e");
        dummy.push(e.currentIndex);
      }
    });
    if (dummy?.length > 0) {
      setMainLoader(true);
      try {
        let b = await claimAll(dummy);
        if (b) {
          setMainLoader(false);
          window.location.reload();
        }
      } catch (err) {
        setMainLoader(false);
        console.log(err, "err");
        toast.error("Transaction reverted");
      }
    }
  };
  const ClaimAll111 = async (e) => {
    let dummy = [];
    totalArry.map((e, i) => {
      if (now > e?.ReleaseTime * 1000 && e?.isClaimed == false) {
        dummy.push(e.currentIndex);
      }
    });
    if (dummy?.length > 0) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  };

  const firstTimeData = async () => {
    try {
      let a = await ethPrice();
      setEthPrice(a);
    } catch (err) {
      console.log(err.message);
    }
  };

  const [copy, setCopy] = useState(false);
  const textCopiedFun2 = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };
  return (
    <>
      {mainLoader1 && <Loader />}
      {mainLoader && (
        <Loader text={"Please wait, your transaction is in process"} />
      )}
      <Navbar show={show} setShow={setShow} />
      <section className="claim">
        <img
          src="/assets/leftshade.png"
          alt="leftshade"
          className="leftshade"
        />
        <img
          src="/assets/rightshade.png"
          alt="rightshade"
          className="rightshade"
        />
        <div className="custom-container">
          <div className="claim-heading">
            <h6>
              {/* Claim <span className="tokenname">${Presale?.symbol}</span> */}
              My Purchases
            </h6>
            {/* <button className="claimallbtn">Claim All</button> */}
          </div>
          <div className="bottom-table">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Purchased on</th>
                    <th>PURCHASE PRICE</th>
                    <th>Amount Spent</th>
                    <th>${Presale?.symbol} PURCHASED</th>
                    <th>TRX Hash</th>
                    <th>TYPE</th>
                    {/* <th>Available on</th> */}
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {totalArry?.map((e) => {
                    let totalPric = 0;
                    let trxHash = e?.transactionHash;
                    let trxHashFormatted = `${trxHash.slice(
                      0,
                      5,
                    )}...${trxHash.slice(-3, trxHash?.length)}`;
                    let selectedType;
                    let a = parseInt(e?.blockTimestamp);
                    let cc = new Date(a);
                    const StackIntialDate = moment(cc * 1000).format(
                      "DD-MM-YYYY H:mm",
                    );
                    let puchased = 0;
                    let selectedTypeCalculation = 0;
                    if (
                      e?.token?.toLowerCase() ===
                        Environment?.usdc?.toLowerCase() ||
                      Environment.wbtc?.toLowerCase() ===
                        e?.token?.toLowerCase() ||
                      Environment.link?.toLowerCase() ===
                        e?.token?.toLowerCase() ||
                      e?.token?.toLowerCase() ===
                        Environment?.busd?.toLowerCase()
                    ) {
                      selectedTypeCalculation =
                        parseFloat(e?.tokenPrice) / 10 ** 8;
                    } else {
                      selectedTypeCalculation =
                        parseFloat(e?.tokenPrice) / 10 ** 10;
                    }

                    // console.log(Environment.tomi,e?.token);
                    if (e?.tokenSelected === "ETH") {
                      const purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                      if (
                        e?.token === "0x" ||
                        e.token === Environment.eth.toLocaleLowerCase()
                      ) {
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        totalPric = kaiFromTokenPurchase(
                          purchasedNum,
                          selectedTypeCalculation,
                          e?.roundPrice,
                        );
                      }
                      puchased = formatDisplayPaymentAmount(purchasedNum);
                      totalPric = kaiFromEthPurchase(
                        purchasedNum,
                        ethPricevalue,
                        e?.roundPrice,
                      );
                    } else if (e?.tokenSelected === "TOKEN") {
                      let purchasedNum = 0;
                      if (
                        e?.token?.toLowerCase() ===
                        Environment.tomi?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "TOMI";
                      } else if (
                        e?.token?.toLowerCase() ===
                        Environment?.busd?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 6);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "USDT";
                      } else if (
                        e?.token?.toLowerCase() ===
                        Environment.gems?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "GEMS";
                      } else if (
                        e?.token?.toLowerCase() ===
                        Environment?.usdc?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 6);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "USDC";
                      } else if (
                        e?.token?.toLowerCase() ===
                        Environment?.wbtc?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 8);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "WBTC";
                      } else if (
                        e?.token?.toLowerCase() ===
                        Environment?.link?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "LINK";
                      } else if (
                        e?.token?.toLowerCase() ===
                        Environment?.pepe?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "PEPE";
                      } else if (
                        e?.token?.toLowerCase() ===
                        Environment?.unisape?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "UNI";
                      } else if (
                        e?.token?.toLowerCase() ===
                        Environment?.dop?.toLowerCase()
                      ) {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "DOP";
                      } else {
                        purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                        puchased = formatDisplayPaymentAmount(purchasedNum);
                        selectedType = "ETH";
                      }

                      totalPric = kaiFromTokenPurchase(
                        purchasedNum,
                        selectedTypeCalculation,
                        e?.roundPrice,
                      );
                    } else {
                      const purchasedNum = fromBaseUnits(e?.amountPurchased, 6);
                      puchased = formatDisplayPaymentAmount(purchasedNum);
                      totalPric = kaiFromUsdPurchase(
                        purchasedNum,
                        e?.roundPrice,
                      );
                    }
                    return (
                      <>
                        <tr>
                          <td>{StackIntialDate}</td>
                          <td>
                            ${" "}
                            {formatDisplayPrice(
                              fromBaseUnits(
                                e?.price ? e?.price : e?.roundPrice,
                                18,
                              ),
                            )}{" "}
                            /${Presale?.symbol}
                          </td>
                          <td>
                            {!puchased || puchased == "NaN"
                              ? `${formatDisplayPaymentAmount(
                                  fromBaseUnits(e?.amountUsd, 6),
                                )} USDT + ${formatDisplayPaymentAmount(
                                  fromBaseUnits(e?.amountEth, 18),
                                )} ETH `
                              : puchased}{" "}
                            {selectedType ? selectedType : e?.tokenSelected}
                          </td>
                          <td>
                            {e?.type === "NFT"
                              ? totalPric
                              : formatDisplayTokenAmount(
                                  fromBaseUnits(e?.tokenPurchased, 18),
                                )}{" "}
                            ${Presale?.symbol}
                          </td>
                          <td>
                            <div className="setflex">
                              <p className="setpara">{trxHashFormatted}</p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                cursor="pointer"
                                onClick={() => {
                                  const weChatShareUrl =
                                    CHAIN == 1
                                      ? `https://etherscan.io/tx/${trxHash}`
                                      : `https://sepolia.etherscan.io/tx/${trxHash}`;

                                  // Open the WeChat share link in a new window
                                  window.open(weChatShareUrl, "_blank");
                                }}
                              >
                                <path
                                  d="M12.25 7.58333V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H6.41667"
                                  stroke="#77868B"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12.25 1.75L7 7"
                                  stroke="#77868B"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M8.75 1.75H12.25V5.25"
                                  stroke="#77868B"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </td>
                          <td>{e?.type === "NFT" ? "NFT" : "TOKEN"}</td>
                          {/* <td>Q1,2024</td> */}

                          {/* {now > e?.ReleaseTime * 1000 ? (
                            <>
                              {e.isClaimed == false ? (
                                <td>
                                  <button
                                    className="btn-claim"
                                    onClick={() => {
                                      handler121(e);
                                    }}
                                  >
                                    Claim
                                  </button>
                                </td>
                              ) : (
                                <td>
                                  <button className="btn-claim claimed">
                                    Claimed
                                  </button>
                                </td>
                              )}
                            </>
                          ) : (
                            <td>
                              <button className="btn-claim disable">
                                Claim
                              </button>
                            </td>
                          )} */}
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>

              {/* <div className="footer-content">
                <div className="left-f">
                  <h6 className="paginationtext">
                    SHOWING {page + 1}-{limit} OF {total}
                  </h6>
                </div>
                <div className="right-f">
                  <nav aria-label="Page navigation example">
                    {pageCount >= 1 ? (
                      <div className="text-center">
                        <ReactPaginate
                          previousLabel={<img src="\assets\arrow1.svg" />}
                          nextLabel={<img src="\assets\arrow2.svg" />}
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageClick}
                          containerClassName="pagination"
                          activeClassName="active"
                          forcePage={page}
                        ></ReactPaginate>
                      </div>
                    ) : (
                      ""
                    )}
                  </nav>
                </div>
              </div> */}
            </div>
            <div className="accmblview d-none">
              {/* <h6 className="accmblviewhead">Purchased on </h6> */}
              {totalArry?.map((e, index) => {
                const eventKey = index.toString();
                let totalPric = 0;
                let trxHash = e?.transactionHash;
                let trxHashFormatted = `${trxHash.slice(
                  0,
                  5,
                )}...${trxHash.slice(-3, trxHash?.length)}`;
                let selectedType;
                let a = parseInt(e?.blockTimestamp);
                let cc = new Date(a);
                const StackIntialDate = moment(cc * 1000).format(
                  "DD-MM-YYYY H:mm",
                );
                let puchased = 0;
                let selectedTypeCalculation = 0;
                if (
                  e?.token?.toLowerCase() ===
                    Environment?.usdc?.toLowerCase() ||
                  Environment.wbtc?.toLowerCase() === e?.token?.toLowerCase() ||
                  Environment.link?.toLowerCase() === e?.token?.toLowerCase() ||
                  e?.token?.toLowerCase() ||
                  e?.token?.toLowerCase() === Environment?.busd?.toLowerCase()
                ) {
                  selectedTypeCalculation = parseFloat(e?.tokenPrice) / 10 ** 8;
                } else {
                  selectedTypeCalculation =
                    parseFloat(e?.tokenPrice) / 10 ** 10;
                }

                // console.log(selectedTypeCalculation,'selectedTypeCalculation',induxc);
                if (e?.tokenSelected === "ETH") {
                  const purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                  if (
                    e?.token === "0x" ||
                    e.token === Environment.eth.toLocaleLowerCase()
                  ) {
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    totalPric = kaiFromTokenPurchase(
                      purchasedNum,
                      selectedTypeCalculation,
                      e?.roundPrice,
                    );
                  }
                  puchased = formatDisplayPaymentAmount(purchasedNum);
                  totalPric = kaiFromEthPurchase(
                    purchasedNum,
                    ethPricevalue,
                    e?.roundPrice,
                  );
                } else if (e?.tokenSelected === "TOKEN") {
                  let purchasedNum = 0;
                  if (
                    e?.token?.toLowerCase() === Environment.tomi?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "TOMI";
                  } else if (
                    e?.token?.toLowerCase() === Environment.gems?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "GEMS";
                  } else if (
                    e?.token?.toLowerCase() === Environment?.busd?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 6);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "USDT";
                  } else if (
                    e?.token?.toLowerCase() === Environment?.usdc?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 6);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "USDC";
                  } else if (
                    e?.token?.toLowerCase() === Environment?.wbtc?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 8);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "WBTC";
                  } else if (
                    e?.token?.toLowerCase() === Environment?.link?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "LINK";
                  } else if (
                    e?.token?.toLowerCase() === Environment?.pepe?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "PEPE";
                  } else if (
                    e?.token?.toLowerCase() === Environment?.dop?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "DOP";
                  } else if (
                    e?.token?.toLowerCase() ===
                    Environment?.unisape?.toLowerCase()
                  ) {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "UNI";
                  } else {
                    purchasedNum = fromBaseUnits(e?.amountPurchased, 18);
                    puchased = formatDisplayPaymentAmount(purchasedNum);
                    selectedType = "ETH";
                  }

                  totalPric = kaiFromTokenPurchase(
                    purchasedNum,
                    selectedTypeCalculation,
                    e?.roundPrice,
                  );
                } else {
                  const purchasedNum = fromBaseUnits(e?.amountPurchased, 6);
                  puchased = formatDisplayPaymentAmount(purchasedNum);
                  totalPric = kaiFromUsdPurchase(purchasedNum, e?.roundPrice);
                }

                return (
                  <>
                    <Accordion
                      className="newaccordion"
                      activeKey={activeKey}
                      onSelect={(key) =>
                        setActiveKey(key === activeKey ? null : key)
                      }
                    >
                      <Accordion.Item eventKey={eventKey} key={eventKey}>
                        <div className="acctop">
                          <div className="topinner">
                            <p className="toppara">Purchased on</p>
                            <h6 className="tophead">{StackIntialDate}</h6>
                          </div>
                          <div className="topinner">
                            <p className="toppara">PURCHASE PRICE</p>
                            <h6 className="tophead">
                              ${" "}
                              {formatDisplayPrice(
                                fromBaseUnits(
                                  e?.price ? e?.price : e?.roundPrice,
                                  18,
                                ),
                              )}{" "}
                              /${Presale?.symbol}
                            </h6>
                          </div>
                          <div className="topinner">
                            <p className="toppara">Amount Spent</p>
                            <h6 className="tophead">
                              {" "}
                              {!puchased || puchased == "NaN"
                                ? `${formatDisplayPaymentAmount(
                                    fromBaseUnits(e?.amountUsd, 6),
                                  )} USDT + ${formatDisplayPaymentAmount(
                                    fromBaseUnits(e?.amountEth, 18),
                                  )} ETH `
                                : puchased}{" "}
                              {selectedType ? selectedType : e?.tokenSelected}
                            </h6>
                          </div>
                          <div className="topinner">
                            <p className="toppara">
                              ${Presale?.symbol} PURCHASED
                            </p>
                            <h6 className="tophead">
                              {e?.type === "NFT"
                                ? totalPric
                                : formatDisplayTokenAmount(
                                    fromBaseUnits(e?.tokenPurchased, 18),
                                  )}{" "}
                              ${Presale?.symbol}
                            </h6>
                          </div>
                        </div>

                        <Accordion.Body>
                          <div className="innerdetail">
                            <p className="detailpara">TRX Hash</p>
                            <a
                              href={
                                CHAIN == 1
                                  ? `https://etherscan.io/tx/${trxHash}`
                                  : `https://sepolia.etherscan.io/tx/${trxHash}`
                              }
                              target="_blank"
                              className="detaillink"
                            >
                              {trxHashFormatted}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M6.66696 3.33366H5.46696C4.72022 3.33366 4.34658 3.33366 4.06136 3.47898C3.81048 3.60681 3.60665 3.81064 3.47882 4.06152C3.3335 4.34674 3.3335 4.72039 3.3335 5.46712V10.5338C3.3335 11.2805 3.3335 11.6537 3.47882 11.9389C3.60665 12.1898 3.81048 12.394 4.06136 12.5218C4.3463 12.667 4.71949 12.667 5.46477 12.667H10.5356C11.2808 12.667 11.6535 12.667 11.9384 12.5218C12.1893 12.394 12.3938 12.1896 12.5216 11.9387C12.6668 11.6538 12.6668 11.281 12.6668 10.5357V9.33366M13.3335 6.00033V2.66699M13.3335 2.66699H10.0002M13.3335 2.66699L8.66683 7.33366"
                                  stroke="#77868B"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </a>
                          </div>
                          <div
                            className="innerdetail"
                            style={{
                              border: "none",
                              margin: "0",
                              padding: "0",
                            }}
                          >
                            <p className="detailpara">TYPE</p>
                            <h6 className="detailhead">
                              {" "}
                              {e?.type === "NFT" ? "NFT" : "TOKEN"}
                            </h6>
                          </div>
                          {/* <div className="lowerbutton">
                            <button className="claimbtn">Claim</button>

                            {now > e?.ReleaseTime * 1000 ? (
                              <>
                                {e.isClaimed == false ? (
                                  <button
                                    className="claimbtn"
                                    onClick={() => {
                                      handler121(e);
                                    }}
                                  >
                                    Claim
                                  </button>
                                ) : (
                                  <button className="claimbtn claimed">
                                    Claimed
                                  </button>
                                )}
                              </>
                            ) : (
                              <button className="claimbtn disable">
                                Claim
                              </button>
                            )}
                          </div> */}
                        </Accordion.Body>
                        <Accordion.Header>
                          {activeKey === eventKey ? "Less info" : "More info"}

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="6"
                            viewBox="0 0 9 6"
                            fill="none"
                            style={{
                              transition: "transform 0.3s ease",
                              transform:
                                activeKey === eventKey
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                            }}
                          >
                            <path
                              d="M7.90908 0H4.09497H0.660442C0.072714 0 -0.22115 0.780597 0.195157 1.23819L3.36644 4.72396C3.87458 5.28249 4.70107 5.28249 5.20921 4.72396L6.41528 3.39829L8.38049 1.23819C8.79068 0.780597 8.49681 0 7.90908 0Z"
                              fill="#02171D"
                            />
                          </svg>
                        </Accordion.Header>
                      </Accordion.Item>
                    </Accordion>
                  </>
                );
              })}

              {/*          
              <div className="footer-content">
                <div className="left-f">
                  <h6 className="paginationtext">
                    SHOWING {page + 1}-{limit} OF {total}
                  </h6>
                </div>
                <div className="right-f">
                  <nav aria-label="Page navigation example">
                    {pageCount >= 1 ? (
                      <div className="text-center">
                        <ReactPaginate
                          previousLabel={<img src="\assets\arrow1.svg" />}
                          nextLabel={<img src="\assets\arrow2.svg" />}
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageClick}
                          containerClassName="pagination"
                          activeClassName="active"
                          forcePage={page}
                        ></ReactPaginate>
                      </div>
                    ) : (
                      ""
                    )}
                  </nav>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Modal
        className="connectwallet-modal followusonx-modal"
        show={show5}
        onHide={handleClose5}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Follow Us</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buydopnft-modal buynft-modal2">
            <img src="\assets\followx.svg" alt="img" className="img-fluid" />
            <h4>Follow Gems on X</h4>
            <p className="newdeisgnpara">
              Follow Gems on X to stay updated with news and announcements{" "}
            </p>
          </div>
          <div className="twice-btnsss">
            <button
              onClick={witterHandler}
              className="btn-proceed sscscscscscsc"
            >
              Follow Gems on X
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Claim;
